module.exports = __webpack_public_path__ + "img/mobil_serve_with_bg.3dfd24c6.png";